import styled from "styled-components";

export const GeneralContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VideoContainer = styled.div`
  width: 80%;
  height: 80%;
  max-width: 907px;
  max-height: 654px;
  position: relative;
  video {
    width: 100%;
  }
  .close-btn {
    position: absolute;
    top: 3%;
    right: 3%;
    z-index: 2;
    cursor: pointer;
  }
`;
